import { render, staticRenderFns } from "./NoDetails.vue?vue&type=template&id=227bd57d"
import script from "./NoDetails.vue?vue&type=script&lang=js"
export * from "./NoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports